export default class TopStory {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'top-story-CTA-click':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'content modul',
                    'eventAction': `${this.vm.linkName} - click`,
                    'eventLabel': `topstory - ${this.vm.title}`,
                    'eventValue': '0',
                    'eventNonInteraction': true,
                    'data': null
                };
                break;
        }

        return trackingObject;
    }
}